function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 10.75l-.41.21h-.01L9.4 13.38l1.07-3.34 3.08-1.39.95 2.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.55 8.65l-3.08 1.39L12 5.25l1.55 3.4zm-3.08 1.39L9.4 13.38 6 12.25l2.18-1.09 1.82-.91.47-.21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 12.25l-4.5 2.5-.31-.1-.09-.03-3.7-1.24 4.68-2.42h.01L18 12.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.19 14.65l-.19.6-1 3-2.5-4.68-.1-.19 3.7 1.24.09.03z"
})));